// Single source of truth for the GENERIC toast system. No game/bet/round
// vocabulary lives here — callers supply all meaning at the call site.
//
// Accent colours are defined here (the JS source of truth). <Toast> applies
// the accent as the `--toast-accent` CSS variable and the SCSS derives every
// tint (fill, border, glow, pill) from that variable via color-mix(), so the
// colour never forks between JS and SCSS.
//
// Sound keys map to the app's EXISTING sound manager keys
// (see src/core/audio/sounds/soundMap.js: CLICK | WON | LOST). `null` = silent.
// Keeping this mapping next to the state config makes it the single, easy to
// retune source of truth for which app sound a state plays.

export const TOAST_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  LOADING: 'loading',
}

export const TOAST_STATES = {
  [TOAST_TYPES.SUCCESS]: {
    accent: '#34E29B',
    iconKey: 'success',
    title: 'Success',
    role: 'status',
    ariaLive: 'polite',
    duration: 4000,
    sound: 'WON',
  },
  [TOAST_TYPES.ERROR]: {
    accent: '#FF5470',
    iconKey: 'error',
    title: 'Something went wrong',
    role: 'alert',
    ariaLive: 'assertive',
    duration: 5000,
    sound: 'LOST',
  },
  [TOAST_TYPES.WARNING]: {
    accent: '#FBB037',
    iconKey: 'warning',
    title: 'Heads up',
    role: 'status',
    ariaLive: 'polite',
    duration: 4500,
    sound: 'CLICK',
  },
  [TOAST_TYPES.INFO]: {
    accent: '#5B9DFF',
    iconKey: 'info',
    title: 'Notice',
    role: 'status',
    ariaLive: 'polite',
    duration: 4000,
    sound: 'CLICK',
  },
  [TOAST_TYPES.LOADING]: {
    accent: '#A78BFA',
    iconKey: 'loading',
    title: 'Working…',
    role: 'status',
    ariaLive: 'polite',
    // Long-lived/pending — stays until resolved by reusing the toast id.
    duration: Infinity,
    // Silent by default; the pending state should not fire a cue.
    sound: null,
  },
}

// Default mount position; overridden live per device by setToastPosition().
export const DEFAULT_TOAST_POSITION = 'top-center'
